import { render } from "./ComprasPage.vue?vue&type=template&id=3ecf6316&scoped=true"
import script from "./ComprasPage.vue?vue&type=script&lang=js"
export * from "./ComprasPage.vue?vue&type=script&lang=js"

import "./ComprasPage.vue?vue&type=style&index=0&id=3ecf6316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecf6316"]])

export default __exports__